// extracted by mini-css-extract-plugin
module.exports = {"shopUIWrapper":"ShopUIWrapper_shopUIWrapper__J_k8T"};